import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, Subscription, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AuthService } from './auth.service';
import { ToastrService } from 'ngx-toastr';
import { LocalStorageService } from './Local-storage.service';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class TokenInterceptorService {
  private dataSubscription: Subscription = new Subscription();
  isLoginShown = false;
  countrySubject: any;
  currencySubject: any;
  affiliateIdSubject: any;
  couponSubject: any;
  customerProfileSubject: any;
  travelAgentSubject: any;
  webSourceSubject: any;

  constructor(
    private router: Router,
    private authService: AuthService,
    private toastr: ToastrService,
    private localStorageService: LocalStorageService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.dataSubscription = this.authService.isLoginShown$.subscribe((data) => {
      this.isLoginShown = data;
    });
    this.localStorageService.countrylocalSubject$.subscribe((res) => {
      this.countrySubject = res;
    });
    this.localStorageService.currencyLocalSubject$.subscribe((res) => {
      this.currencySubject = res;
    });
    this.localStorageService.affiliateIdSubject$.subscribe((res) => {
      this.affiliateIdSubject = res;
    });
    this.localStorageService.couponSubject$.subscribe((res) => {
      this.couponSubject = res;
    });
    this.localStorageService.customerProfileSubject$.subscribe((res) => {
      this.customerProfileSubject = res;
    });
    this.localStorageService.travelAgentSubject$.subscribe((res) => {
      if (isPlatformBrowser(this.platformId)) {
        this.travelAgentSubject = res || localStorage.getItem('Trip_Travel_Agent');
        }
    });
    this.localStorageService.webSourceSubject$.subscribe((res) => {
      this.webSourceSubject = res;
    });
  }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const token: string | null = this.authService.getToken();
    const currency: string | null = this.currencySubject;
    const country: string | null = this.countrySubject;
    const travelAgent: string | null =this.travelAgentSubject;
    const afiliateId: string | null = this.affiliateIdSubject;
    const customerProfile: string | null = this.customerProfileSubject;
    const webSource: string | null = this.webSourceSubject;
    const coupon: string | null = this.couponSubject;

    const headersConfig: { [name: string]: string | string[] } = {};

    if (token) {
      headersConfig['Authorization'] = `Bearer ${token}`;
    }

    if (afiliateId) {
      headersConfig['affiliate'] = JSON.parse(afiliateId);
    }

    if (travelAgent && travelAgent !== 'undefined') {
      headersConfig['Travel-Agent'] = JSON.parse(travelAgent);
    }

    if (customerProfile && customerProfile !== 'undefined') {
      const customer = JSON.parse(customerProfile);
      headersConfig['Source'] = customer?.source || 'WEB';
    }

    if (country) {
      headersConfig['country'] = country;
    }

    if (currency) {
      headersConfig['currency'] = currency;
    }
    if (coupon) {
      headersConfig['coupon'] = coupon;
    }

    if (webSource && webSource !== 'undefined') {
      headersConfig['White-Label-Source'] = webSource;
    }

    request = request.clone({ setHeaders: headersConfig });

    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          if (!this.isLoginShown) {
            this.isLoginShown = true;
            this.authService.updateLoginPopShown(true);
            this.authService.updateCustomer('404');
            this.authService.logout();
          }
        } else if (error.status === 400) {
          this.toastr.error(error?.error?.message);
        }
        return throwError(error);
      })
    );
  }

  ngOnDestroy() {
    this.dataSubscription.unsubscribe();
  }
}
